/*
 * Beneath Zero - free shipping bar / WSH Wholesale Pricing sync
 *
 * Shopify's cart.total_price does not include prices that WSH Wholesale Pricing
 * applies client-side on the storefront. WSH updates the cart's displayed total
 * after its own script has run. This helper keeps the theme's free-shipping bar
 * aligned with that final displayed total, so the message matches the amount
 * Shopify/WSH sends through to checkout.
 */
(function () {
  'use strict';

  var refreshQueued = false;

  function parseMoneyToCents(text) {
    if (!text) return null;

    var matches = String(text)
      .replace(/\u00a0/g, ' ')
      .match(/-?\d[\d\s.,]*/g);

    if (!matches || !matches.length) return null;

    // WSH can show an original crossed-out total followed by the wholesale total.
    // Work backwards so the final/current price is used.
    for (var i = matches.length - 1; i >= 0; i -= 1) {
      var raw = matches[i].replace(/\s/g, '');
      var lastComma = raw.lastIndexOf(',');
      var lastDot = raw.lastIndexOf('.');
      var decimalSeparator = null;

      if (lastComma > -1 && lastDot > -1) {
        decimalSeparator = lastComma > lastDot ? ',' : '.';
      } else if (lastComma > -1) {
        decimalSeparator = raw.length - lastComma - 1 === 2 ? ',' : null;
      } else if (lastDot > -1) {
        decimalSeparator = raw.length - lastDot - 1 === 2 ? '.' : null;
      }

      if (decimalSeparator === ',') {
        raw = raw.replace(/\./g, '').replace(',', '.');
      } else if (decimalSeparator === '.') {
        raw = raw.replace(/,/g, '');
      } else {
        raw = raw.replace(/[.,]/g, '');
      }

      var value = Number(raw);
      if (Number.isFinite(value)) {
        return Math.round(value * 100);
      }
    }

    return null;
  }

  function getWholesaleAwareCartTotal(bar) {
    // Older/current WSH integrations expose a discounted cart total here.
    try {
      if (
        window.wcp_data &&
        window.wcp_data.discounted_hash &&
        window.wcp_data.discounted_hash.wcp_total !== undefined &&
        window.wcp_data.discounted_hash.wcp_total !== null &&
        window.wcp_data.discounted_hash.wcp_total !== false
      ) {
        var wcpTotal = Number(window.wcp_data.discounted_hash.wcp_total);
        if (Number.isFinite(wcpTotal)) {
          return Math.round(wcpTotal * 100);
        }
      }
    } catch (error) {
      // Fall through to the DOM value below.
    }

    // Full cart page: WSH populates this only when a wholesale price is active.
    var wcpCartTotal = document.querySelector('.wcp-cart-total');
    if (wcpCartTotal && wcpCartTotal.textContent.trim()) {
      var fullCartCents = parseMoneyToCents(wcpCartTotal.textContent);
      if (fullCartCents !== null) return fullCartCents;
    }

    // Cart drawer: WSH updates the checkout button total. It can contain the
    // crossed-out retail total followed by the wholesale total; parser uses last.
    var drawerTotal = document.querySelector('[data-wpd-cart-total]');
    if (drawerTotal && drawerTotal.textContent.trim()) {
      var drawerCents = parseMoneyToCents(drawerTotal.textContent);
      if (drawerCents !== null) return drawerCents;
    }

    // Retail / native Shopify-discount fallback.
    var liquidTotal = Number(bar.getAttribute('data-cart-total'));
    return Number.isFinite(liquidTotal) ? liquidTotal : 0;
  }

  function updateBar(bar) {
    var threshold = Number(bar.getAttribute('data-amount-cents'));
    if (!Number.isFinite(threshold) || threshold <= 0) return;

    var total = getWholesaleAwareCartTotal(bar);
    var currency = bar.getAttribute('data-threshold-currency') ||
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      'EUR';
    var amountMessage = bar.getAttribute('data-amount-message') || '';
    var successMessage = bar.getAttribute('data-success-message') || '';
    var amountElement = bar.querySelector('.js-cart-shipping-amount-msg');
    var hiddenProgress = bar.querySelector('.js-shipping-bar-progress-hidden-text');
    var percentage = (total / threshold) * 100;

    if (!Number.isFinite(percentage)) percentage = 0;
    percentage = Math.max(0, Math.min(100, percentage));

    bar.style.setProperty('--shipping-bar-progress-value', percentage);
    bar.setAttribute('data-effective-cart-total', String(total));

    if (hiddenProgress && window.themeCore && window.themeCore.translations) {
      try {
        hiddenProgress.textContent = window.themeCore.translations
          .get('cart.shipping_bar.progress')
          .replace('{{ value }}', percentage.toFixed(1));
      } catch (error) {
        // Accessibility text is optional; do not block the visible message.
      }
    }

    if (!amountElement) return;

    if (total < threshold) {
      var remaining = threshold - total;
      var formattedRemaining;

      try {
        formattedRemaining = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currency
        }).format(remaining / 100);
      } catch (error) {
        formattedRemaining = (remaining / 100).toFixed(2);
      }

      amountElement.innerHTML = amountMessage.replace(
        '{amount}',
        '<strong class="cart-shipping__amount">' + formattedRemaining + '</strong>'
      );
    } else {
      amountElement.innerHTML = successMessage;
    }
  }

  function refreshBars() {
    refreshQueued = false;
    var bars = document.querySelectorAll('.js-cart-shipping');
    for (var i = 0; i < bars.length; i += 1) {
      updateBar(bars[i]);
    }
  }

  function queueRefresh() {
    if (refreshQueued) return;
    refreshQueued = true;
    window.requestAnimationFrame(refreshBars);
  }

  function mutationNeedsRefresh(mutation) {
    var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;

    // Ignore mutations created by this helper while updating the bar itself.
    if (target && target.closest && target.closest('.js-cart-shipping')) return false;

    if (
      target &&
      target.closest &&
      (target.closest('[data-wpd-cart-total]') ||
        target.closest('.wcp-cart-total') ||
        target.closest('[data-section-type="cart-template"]'))
    ) {
      return true;
    }

    if (mutation.addedNodes && mutation.addedNodes.length) {
      for (var i = 0; i < mutation.addedNodes.length; i += 1) {
        var node = mutation.addedNodes[i];
        if (node.nodeType !== 1) continue;
        if (
          (node.matches &&
            (node.matches('.js-cart-shipping') ||
              node.matches('[data-wpd-cart-total]') ||
              node.matches('.wcp-cart-total'))) ||
          (node.querySelector &&
            (node.querySelector('.js-cart-shipping') ||
              node.querySelector('[data-wpd-cart-total]') ||
              node.querySelector('.wcp-cart-total')))
        ) {
          return true;
        }
      }
    }

    return false;
  }

  function init() {
    refreshBars();

    // WSH pricing is asynchronous, so repeat a few harmless checks during startup.
    window.setTimeout(queueRefresh, 100);
    window.setTimeout(queueRefresh, 400);
    window.setTimeout(queueRefresh, 1000);
    window.setTimeout(queueRefresh, 2000);

    if (!document.body || !window.MutationObserver) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutationNeedsRefresh(mutations[i])) {
          queueRefresh();
          return;
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });

    if (window.themeCore && window.themeCore.EventBus && window.themeCore.EventBus.listen) {
      window.themeCore.EventBus.listen('cart:updated', queueRefresh);
      window.themeCore.EventBus.listen('cart:refresh', queueRefresh);
      window.themeCore.EventBus.listen('cart:drawer:open', queueRefresh);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
